/**
 * TTS (Text-to-Speech) API
 * Endpoint is controlled via TTS2_API_ENDPOINT in .env
 * Falls back to AIPNT_API_URL + /api/tts if TTS2_API_ENDPOINT is not set
 */
const TTS_ENDPOINT = process.env.TTS2_API_ENDPOINT ||
    (process.env.AIPNT_API_URL ? `${process.env.AIPNT_API_URL}/api/tts` : null);

const postJson = async (url, body) => {
    const response = await fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        throw new Error(`TTS service returned HTTP ${response.status}`);
    }

    return response.json();
};

const requestSpeechAudio = async payload => {
    if (!TTS_ENDPOINT) {
        throw new Error('TTS endpoint is not configured. Set TTS2_API_ENDPOINT or AIPNT_API_URL in your .env file.');
    }
    return postJson(TTS_ENDPOINT, payload);
};

export {
    requestSpeechAudio
};
